import React, {useCallback} from 'react'
import {graphql, usePaginationFragment} from 'react-relay/hooks'
import {Box, BoxProps, Stack} from '@chakra-ui/react'

import {GameList_provider_games$key} from './__generated__/GameList_provider_games.graphql'
import {GameFeed} from 'components/GameFeed'
import {GameListItemSkeleton} from 'components/GameListItem'

interface GameListProps {
  provider: GameList_provider_games$key
}

const NUMBER_OF_GAMES_PER_PAGE = 10

export function GameList({
  provider: _provider,
  ...props
}: GameListProps & BoxProps) {
  const {data, hasNext, isLoadingNext, loadNext} = usePaginationFragment(
    graphql`
      fragment GameList_provider_games on Provider
      @argumentDefinitions(
        count: {type: "Int", defaultValue: 5}
        cursor: {type: "String"}
        youth: {type: "Boolean"}
      )
      @refetchable(queryName: "ProviderProviderIndexGameListPaginationQuery") {
        games(
          after: $cursor
          first: $count
          orderBy: {direction: ASC, field: START_TIME}
          times: [UPCOMING]
          youth: $youth
        ) @connection(key: "GameList_provider_games") {
          edges {
            node {
              ...GameFeed_games
            }
          }
        }
      }
    `,
    _provider
  )

  const onLoadMore = useCallback(() => {
    if (hasNext) {
      loadNext(NUMBER_OF_GAMES_PER_PAGE)
    }
  }, [hasNext, loadNext])

  return (
    <Box {...props}>
      <GameFeed
        games={data.games.edges.map(({node}) => node)}
        gameType="full"
        onLoadMore={hasNext ? onLoadMore : undefined}
      />
      {isLoadingNext && (
        <Stack mt={4} spacing={4}>
          <GameListItemSkeleton />
          <GameListItemSkeleton />
          <GameListItemSkeleton />
        </Stack>
      )}
    </Box>
  )
}
